const initialState = {
    availableTime: null,
  };
  
  const timerLockReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_TIMERLOCK':
        return {
          ...state,
          availableTime: action.payload,
        };
      case 'CLEAR_TIMERLOCK':
        return {
          ...state,
          availableTime: null,
        };
      default:
        return state;
    }
  };
  
  export default timerLockReducer;
  